import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useSectionContent } from "@/hooks/useContent";

export default function FlagFeature() {
  const c = useSectionContent("flag");
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      ref={ref}
      data-testid="flag-feature-section"
      className="relative h-[70vh] sm:h-[85vh] overflow-hidden"
    >
      <motion.div style={{ y }} className="absolute inset-0 scale-125">
        <img
          src={c.image_url}
          alt={c.title}
          className="w-full h-full object-cover"
        />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B] via-transparent to-[#0A0A0B]" />
      <div className="absolute inset-0 bg-[#0A0A0B]/25" />

      <div className="absolute bottom-0 inset-x-0 pb-14 px-5 sm:px-8">
        <div className="max-w-7xl mx-auto">
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
            className="font-mono text-[11px] uppercase tracking-[0.4em] text-[#C5A059]"
          >
            {c.overline}
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="mt-3 font-display text-3xl sm:text-5xl font-bold text-[#F4EBE1] max-w-2xl leading-tight"
          >
            {c.title}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mt-4 text-sm sm:text-base text-[#C0B9B0] max-w-xl leading-relaxed"
          >
            {c.description}
          </motion.p>
        </div>
      </div>
    </section>
  );
}
